import type { AccentPalette } from "../types";

export const ACCENT_MUTED_DUSTY: AccentPalette = {
    label: "Muted / Dusty",
    inflow: { base: "#4AA584", selected: "#72C0A3" },
    outflow: { base: "#BD7556", selected: "#CE9982" },
    icons: {
        "ri-account-circle-line": { pillHex: "#D5ECDD", chartHex: "#70C28B" },
        "ri-arrow-left-right-line": { pillHex: "#E3D5EC", chartHex: "#B186CB" },
        "ri-bank-card-line": { pillHex: "#ECEAD5", chartHex: "#B9B15B" },
        "ri-bank-line": { pillHex: "#D5E7EC", chartHex: "#70B1C2" },
        "ri-bill-line": { pillHex: "#ECD5E0", chartHex: "#CB86A8" },
        "ri-book-2-line": { pillHex: "#DAECD5", chartHex: "#6EB95B" },
        "ri-bookmark-line": { pillHex: "#D7D5EC", chartHex: "#7770C2" },
        "ri-box-3-line": { pillHex: "#ECDDD5", chartHex: "#CBA086" },
        "ri-briefcase-line": { pillHex: "#D5ECE4", chartHex: "#5BB999" },
        "ri-building-line": { pillHex: "#EBD5EC", chartHex: "#BE70C2" },
        "ri-calculator-line": { pillHex: "#E6ECD5", chartHex: "#BACB86" },
        "ri-car-line": { pillHex: "#D5DFEC", chartHex: "#5B86B9" },
        "ri-cash-line": { pillHex: "#ECD5D9", chartHex: "#C2707E" },
        "ri-coins-line": { pillHex: "#D5ECD8", chartHex: "#86CB8E" },
        "ri-computer-line": { pillHex: "#DED5EC", chartHex: "#825BB9" },
        "ri-exchange-dollar-line": { pillHex: "#ECE5D5", chartHex: "#C2AA70" },
        "ri-file-list-3-line": { pillHex: "#D5ECEC", chartHex: "#86CBCB" },
        "ri-file-paper-2-line": { pillHex: "#ECD5E5", chartHex: "#B95B9D" },
        "ri-funds-line": { pillHex: "#DEECD5", chartHex: "#92C270" },
        "ri-gift-line": { pillHex: "#D5D8EC", chartHex: "#868ECB" },
        "ri-government-line": { pillHex: "#ECD9D5", chartHex: "#B96A5B" },
        "ri-group-line": { pillHex: "#D5ECDF", chartHex: "#70C296" },
        "ri-hammer-line": { pillHex: "#E6D5EC", chartHex: "#BA86CB" },
        "ri-hand-coin-line": { pillHex: "#EBECD5", chartHex: "#B5B95B" },
        "ri-home-8-line": { pillHex: "#D5E4EC", chartHex: "#70A7C2" },
        "ri-landscape-line": { pillHex: "#ECD5DD", chartHex: "#CB86A0" },
        "ri-lightbulb-line": { pillHex: "#D7ECD5", chartHex: "#63B95B" },
        "ri-line-chart-line": { pillHex: "#DAD5EC", chartHex: "#8170C2" },
        "ri-macbook-line": { pillHex: "#ECE0D5", chartHex: "#CBA886" },
        "ri-megaphone-line": { pillHex: "#D5ECE7", chartHex: "#5BB9A5" },
        "ri-money-dollar-circle-line": { pillHex: "#ECD5EA", chartHex: "#C270BB" },
        "ri-percent-line": { pillHex: "#E3ECD5", chartHex: "#B1CB86" },
        "ri-pie-chart-2-line": { pillHex: "#D5DDEC", chartHex: "#5B7AB9" },
        "ri-pie-chart-line": { pillHex: "#ECD5D6", chartHex: "#C27074" },
        "ri-printer-line": { pillHex: "#D5ECDB", chartHex: "#86CB97" },
        "ri-question-line": { pillHex: "#E1D5EC", chartHex: "#8E5BB9" },
        "ri-receipt-line": { pillHex: "#ECE8D5", chartHex: "#C2B470" },
        "ri-safe-line": { pillHex: "#D5E9EC", chartHex: "#86C2CB" },
        "ri-scales-3-line": { pillHex: "#ECD5E2", chartHex: "#B95B92" },
        "ri-settings-4-line": { pillHex: "#DCECD5", chartHex: "#88C270" },
        "ri-shake-hands-line": { pillHex: "#D5D5EC", chartHex: "#8686CB" },
        "ri-shield-check-line": { pillHex: "#ECDCD5", chartHex: "#B9765B" },
        "ri-shopping-bag-3-line": { pillHex: "#D5ECE2", chartHex: "#70C2A0" },
        "ri-stock-line": { pillHex: "#E9D5EC", chartHex: "#C286CB" },
        "ri-store-2-line": { pillHex: "#E8ECD5", chartHex: "#A9B95B" },
        "ri-team-line": { pillHex: "#D5E1EC", chartHex: "#709CC2" },
        "ri-time-line": { pillHex: "#ECD5DB", chartHex: "#CB8697" },
        "ri-timer-line": { pillHex: "#D5ECD6", chartHex: "#5BB95F" },
        "ri-tools-line": { pillHex: "#DDD5EC", chartHex: "#8B70C2" },
        "ri-truck-line": { pillHex: "#ECE3D5", chartHex: "#CBB186" },
        "ri-umbrella-line": { pillHex: "#D5ECEA", chartHex: "#5BB9B1" },
        "ri-user-settings-line": { pillHex: "#ECD5E7", chartHex: "#C270B1" },
        "ri-wallet-line": { pillHex: "#E0ECD5", chartHex: "#A8CB86" },
    },
};
